import React from 'react';

const SoccerPitch = ({ lineup }) => {
    return (
        <main className="lineup-main">
            <div className="pitch-container">
                <div className="pitch soccer-pitch">
                    <div className="center-line"></div>
                    <div className="center-circle"></div>
                    <div className="penalty-area penalty-left"></div>
                    <div className="penalty-area penalty-right"></div>
                    <div className="corner top-left"></div>
                    <div className="corner top-right"></div>
                    <div className="corner bottom-left"></div>
                    <div className="corner bottom-right"></div>

                    <div className="players-container">
                        {lineup.players.map((p, idx) => (
                            <div key={`${p.playerId}-${idx}`} className="player-card" style={{ left: `${p.positionX}%`, top: `${p.positionY}%` }}>
                                <div className="kit-circle">
                                    {p.dorsal}
                                    {p.isCaptain && <div className="captain-badge">C</div>}
                                </div>
                                <div className="player-info">
                                    <div className="player-name">{p.name}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="dt-card left">
                <div className="kit-circle dt-kit">DT</div>
                <div className="player-info">
                    <div className="player-name">{lineup.managerName}</div>
                </div>
            </div>
        </main>
    );
};

export { SoccerPitch };